export const EVENTS = [
  { id: "evt-domingo", date: "2026-07-19", category: "servicio",
    title: { es: "Servicio Dominical", en: "Sunday Service" },
    time: { es: "Domingos · 10:30 AM", en: "Sundays · 10:30 AM" },
    location: "91 Oak Creek Dr, Kaufman, TX 75142",
    description: { es: "Adoración, palabra y comunidad. Café desde las 10:00 AM.",
                   en: "Worship, word and community. Coffee from 10:00 AM." } },
  { id: "evt-estudio", date: "2026-07-23", category: "familias",
    title: { es: "Estudio Bíblico y Discipulado", en: "Bible Study & Discipleship" },
    time: { es: "Jueves · 7:00 PM", en: "Thursday · 7:00 PM" },
    location: "91 Oak Creek Dr, Kaufman, TX 75142",
    description: { es: "Crecimiento para padres e hijos. Cuidado de niños disponible.",
                   en: "Growth for parents and kids. Childcare available." } },
  { id: "evt-jovenes", date: "2026-07-24", category: "jovenes",
    title: { es: "MVMT Jóvenes: Noche de Conexión", en: "MVMT Youth: Connection Night" },
    time: { es: "Viernes · 7:00 PM", en: "Friday · 7:00 PM" },
    location: "91 Oak Creek Dr, Kaufman, TX 75142",
    description: { es: "Juegos, adoración y un mensaje relevante para estudiantes de 12 a 18 años.",
                   en: "Games, worship and a relevant message for students ages 12-18." } },
  { id: "evt-adoracion", date: "2026-07-31", category: "adoracion",
    title: { es: "Noche de Adoración y Oración", en: "Worship & Prayer Night" },
    time: { es: "Viernes 31 Jul · 7:30 PM", en: "Friday Jul 31 · 7:30 PM" },
    location: "91 Oak Creek Dr, Kaufman, TX 75142",
    description: { es: "Una noche para recargar el corazón. Entrada libre.",
                   en: "A night to recharge your heart. Free entry." } },
  { id: "evt-desayuno", date: "2026-08-08", category: "comunidad",
    title: { es: "Desayuno Comunitario Kaufman", en: "Kaufman Community Breakfast" },
    time: { es: "Sábado · 9:00 AM", en: "Saturday · 9:00 AM" },
    location: "91 Oak Creek Dr, Kaufman, TX 75142",
    description: { es: "Servimos a nuestra ciudad con un desayuno gratuito para vecinos.",
                   en: "We serve our city with a free breakfast for neighbors." } },
];

export const CONTACT_EMAIL = "info@movimientotx.com";
